/**
 * Created by sswaminathan on 1/9/23
 * File: BackBoneRegionCheckBox
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { Checkbox } from '@panwds/react-ui'
import { capitalize } from 'lodash'
import { useEffect, useState } from 'react'
/**
 *   TODO: Brief what is this component/class do
 */
const BackBoneRegionCheckBox = ({ value, callback, isRegionPresent }) => {
  const [checked, setChecked] = useState(false)
  useEffect(() => {
    setChecked(isRegionPresent)
  }, [isRegionPresent])
  return <Checkbox checked={checked} onChange={() => {
    callback(value, checked)
    setChecked(!checked)
  }}>
    {capitalize(value.region)}
  </Checkbox>
}

BackBoneRegionCheckBox.propTypes = {}
export default BackBoneRegionCheckBox
